import { SortMenuOptions } from 'shared/types/sort-menu-options';
import { GoalSortingMode, GroupByMode } from 'shared/types/sorting-mode';

import { GroupByMenuOptions } from './menu-options';

export const groupByOptions: GroupByMenuOptions[] = [
  {
    id: GroupByMode.None,
    value: GroupByMode.None,
    label: `pages.goals.group-by.label.${GroupByMode.None}`,
  },
  {
    id: GroupByMode.LifeArea,
    value: GroupByMode.LifeArea,
    label: `pages.goals.group-by.label.${GroupByMode.LifeArea}`,
  },
];

export const sortOptions: SortMenuOptions<GoalSortingMode>[] = [
  {
    id: GoalSortingMode.Custom,
    value: GoalSortingMode.Custom,
    label: `general.labels.goals.sort.options.${GoalSortingMode.Custom}`,
  },
  {
    id: GoalSortingMode.StartDate,
    value: GoalSortingMode.StartDate,
    label: `general.labels.goals.sort.options.${GoalSortingMode.StartDate}`,
  },
  {
    id: GoalSortingMode.Deadline,
    value: GoalSortingMode.Deadline,
    label: `general.labels.goals.sort.options.${GoalSortingMode.Deadline}`,
  },
  {
    id: GoalSortingMode.Progress,
    value: GoalSortingMode.Progress,
    label: `general.labels.goals.sort.options.${GoalSortingMode.Progress}`,
  },
];
